import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ViewportService {

  private isLargeViewport: boolean = true;

  isLargeViewPort(): boolean {
    return this.isLargeViewport
  }

  checkViewportSize(): void {
    this.isLargeViewport = window.innerWidth >= 900;
  }
}
